<template>
  <div class="company-core-scope">
    <div class="company-core-scope-head">
      <bcc-breadcrumb>
        <bcc-breadcrumb-item>管理中心</bcc-breadcrumb-item>
        <bcc-breadcrumb-item :to="{name: 'companyCore'}" @click.native="$LogReport.sendCustomEvent('openplat_checkscope_backto_appmanage')">{{app_name}}</bcc-breadcrumb-item>
        <bcc-breadcrumb-item>接口信息</bcc-breadcrumb-item>
      </bcc-breadcrumb>
    </div>
    <div class="company-core-scope-body">
      <div class="company-core-scope-body-h">
        <h3>接口信息</h3>
        <bcc-tabs @on-change="tabsChange">
          <bcc-tab label="视频权限" id="videoScope"></bcc-tab>
<!--          <bcc-tab label="用户权限" id="userScope"></bcc-tab>-->
<!--          <bcc-tab label="数据权限" id="dataScope"></bcc-tab>-->
<!--          <bcc-tab label="特殊权限" id="specScope"></bcc-tab>-->
        </bcc-tabs>
      </div>
      <div class="company-core-scope-body-b" v-if="multiStep === 1">
        <div class="search-add">
          <bcc-search-input
              v-if="!showMultipleScopeAdd"
              placeholder="请搜索权限名称，支持模糊搜索"
              :disabled="showMultipleScopeAdd"
              class="search-api"
              @on-search="onSearchScopesName"
              @click.native="$LogReport.sendCustomEvent('openplat_checkscope_search_click')"
          ></bcc-search-input>
          <div v-else class="search-api"></div>
          <bcc-button type='blueLine' size="middle" @click="setMultipleScopeAdd" :disabled="!scopes_key_options.length || !!showMultipleScopeAdd || !!searchScopesName || !enableMutiBtn">批量申请</bcc-button>
        </div>
        <bcc-table
          :columns="companyCoreScopeColumn"
          :data="_companyCoreScopeData_"
          emptyText="当前没有应用"
          :show-loading="scopeDataLoading"
          align="center"
        >
          <template slot="scopes_name" slot-scope="scope">
            <v-icon v-if="multipleRowSelected(scope.row)" @click="selectScope(scope.row, false)" name="selected" style="color: #1389BF; width: 16px; height: 16px; vertical-align: middle; margin-right: 10px; cursor: pointer;"></v-icon>
            <v-icon v-if="multipleRowNotSelected(scope.row)" @click="selectScope(scope.row, true)" name="default-selected" style="color: #1389BF; width: 16px; height: 16px; vertical-align: middle; margin-right: 10px; cursor: pointer;"></v-icon>
            <span style="vertical-align: middle;" v-if="!searchScopesName">{{scope.row.scopes_name}}</span>
            <span style="vertical-align: middle;" v-else v-html="renderSearchScopeName(scope.row.scopes_name)"></span>
          </template>
          <template slot="scopes_api" slot-scope="scope">
            <div>
              <p class="ellipsis-1" v-for="(api, idx) in scope.row.scopes_api" :key="idx">{{api}}</p>
            </div>
            <!-- <i class="bcc-iconfont bcc-icon-ic_drop-down arcopen-pointer"
               v-if="scope.row.show_api_expand && !scope.row.api_expand"
               @click.stop="scope.row.api_expand = !scope.row.api_expand"></i>
            <i class="bcc-iconfont bcc-icon-ic_pull arcopen-pointer"
               v-if="scope.row.show_api_expand && scope.row.api_expand"
               @click.stop="scope.row.api_expand = !scope.row.api_expand"></i> -->
          </template>

          <template slot="scopes_desc" slot-scope="scope">
            <div class="desc-row-expand">
              <span class="row-expand-name">{{scope.row.scopes_desc}}</span>
              <!-- <i class="bcc-iconfont bcc-icon-ic_drop-down arcopen-pointer"
                 v-if="scope.row.show_desc_expand && !scope.row.desc_expand"
                 @click.stop="scope.row.desc_expand = !scope.row.desc_expand"></i>
              <i class="bcc-iconfont bcc-icon-ic_pull arcopen-pointer"
                 v-if="scope.row.show_desc_expand && scope.row.desc_expand"
                 @click.stop="scope.row.desc_expand = !scope.row.desc_expand"></i> -->
            </div>
          </template>

          <template slot="state" slot-scope="scope">
            <span v-html="renderScopeState(scope.row.state)"></span>
            <v-icon v-if='scope.row.state === 3' class="reject-help-img" slot="reference" name='help' @click="handleShowReason(scope)" />
          </template>

          <template slot="operate" slot-scope="scope">
            <span v-if='showMultipleScopeAdd' class="scope-operate disabled">接口文档</span>
            <router-link v-else class="scope-operate" @click.native="$LogReport.sendCustomEvent('openplat_checkscope_apifile_click')" :to="{path: getPath(scope.row)}">接口文档</router-link>
            <span class="scope-operate" :class="{'disabled': !scopes_key_options.length || showMultipleScopeAdd}" v-if="scope.row.state === 0" @click="!(!scopes_key_options.length || showMultipleScopeAdd) && openSpecificScopeAdd(scope.row)">申请</span>
            <span v-if='scope.row.state === 3' :class="{'disabled': showMultipleScopeAdd}" @click="!showMultipleScopeAdd && openSpecificScopeAdd(scope.row)" class="scope-operate">重新申请</span>
          </template>
        </bcc-table>
      </div>
      <div class="company-core-scope-body-b-multiple-add" v-if="(showMultipleScopeAdd || showSingleAdd) && multiStep === 2">
        <p class="top-text">您已经选择<span style="color: #00A1D6;">{{companyCoreMultipleAddData.length}}</span>个接口，请在此确认并填写申请理由</p>
        <bcc-table
          :columns="companyCoreMultipleAddScopeColumn"
          :data="companyCoreMultipleAddData"
          emptyText=""
          align="center"
          style="margin-top: 27px"
        >
          <template slot="scopes_api" slot-scope="scope">
            <div>
              <p class="ellipsis-1" v-for="(api, idx) in scope.row.scopes_api" :key="idx">{{api}}</p>
            </div>
            <!-- <i class="bcc-iconfont bcc-icon-ic_drop-down arcopen-pointer"
               v-if="scope.row.show_api_expand && !scope.row.api_expand"
               @click.stop="scope.row.api_expand = !scope.row.api_expand"></i>
            <i class="bcc-iconfont bcc-icon-ic_pull arcopen-pointer"
               v-if="scope.row.show_api_expand && scope.row.api_expand"
               @click.stop="scope.row.api_expand = !scope.row.api_expand"></i> -->
          </template>
          <template slot="reason" slot-scope="scope">
            <bcc-input
              maxlength="80"
              :isError="false"
              style="width: 100%; background-color: #ffffff;"
              rows="5"
              type="textarea"
              placeholder="请输入申请理由"
              v-model="scope.row.reason"
              showWordLimit
            ></bcc-input>
          </template>
          <template slot="operate" slot-scope="scope">
            <span class="scope-operate" @click="removeMultiAdd(scope.row)">移除</span>
          </template>
        </bcc-table>
      </div>
      <div class="company-core-scope-body-b-multiple-add-success" v-if="showMultipleScopeAdd && multiStep === 3">
        <img src="../../assets/success-application.png" alt="">
        <p>提交成功， 我们会在2～3个工作日内审核您的申请</p>
        <p style="color: #999999;">如有疑问请联系<span style="color: #23ADE5;">openplatform-feedback@bilibili.com</span></p>
      </div>
      <div class="company-core-scope-body-multi-op" v-if="showMultipleScopeAdd || showSingleAdd">
        <div class="multi-step multi-step-1" v-if="multiStep === 1 && showMultipleScopeAdd">
          <div class="info">
            <span>您已经选择</span>
            <span style="color: #00A1D6;">{{multipleScopeSelectCount}}</span>
            <span>个权限</span>
          </div>
          <div class="btn-groups">
            <bcc-button type="default" size="large" @click="cancelBatch">取消批量</bcc-button>
            <bcc-button type="primary" size="large" :disabled="multipleScopeSelectCount <= 0" style="margin-left: 16px" @click="nextMultipleSelect">下一步</bcc-button>
          </div>
        </div>
        <div class="multi-step multi-step-2" v-if="multiStep === 2">
          <div class="info">
            <span>申请理由已填写</span>
            <span> {{ reasonNum }}/{{ companyCoreMultipleAddData.length }}</span>
          </div>
          <div class="btn-groups">
            <bcc-button type="default" size="large" :disabled="submitMultipleScopeAddLoading" @click="multiStep = 1">上一步</bcc-button>
            <bcc-button type="primary" size="large" :disabled="submitMultipleScopeAddLoading" style="margin-left: 16px" @click="submitMultipleScopeAdd">提交</bcc-button>
          </div>
        </div>
      </div>
    </div>
    <RejectDialog ref='dialog' />
    <scope-add :scopes_key_options="scopes_key_options" @close="showScopeAdd = false" @ok="confirmScopeAdd" v-if="showScopeAdd" ref="scopeAdd"/>
  </div>
</template>

<script>
import scopeAdd from './scope-add'
import RejectDialog from './rejectDialog'

export default {
  name: "companyCoreScope",
  data() {
    return {
      app_name: '',
      showScopeAdd: false,
      showMultipleScopeAdd: false,
      multiStep: 1,
      companyCoreScopeColumn: [
        {
          title: '权限名称',
          key: 'scopes_name',
          style: {
            width: '160px',
            'vertical-align': 'middle'
          }
        },
        {
          title: '权限介绍',
          key: 'scopes_desc',
          style: {
            'text-align': 'left',
            'vertical-align': 'middle'
          }
        },
        {
          title: 'scope',
          key: 'scopes_api',
          style: {
            'text-align': 'left',
            width: '220px',
            'vertical-align': 'middle'
          }
        },
        {
          title: '权限状态',
          key: 'state',
          style: {
            width: '140px',
            'vertical-align': 'middle'
          }
        },
        {
          title: '操作',
          key: 'operate',
          style: {
            width: '200px',
            'vertical-align': 'middle'
          }
        }
      ],
      companyCoreMultipleAddScopeColumn: [
        {
          title: '权限名称',
          key: 'scopes_name',
          style: {
            'vertical-align': 'middle'
          }
        },
        {
          title: 'scope',
          key: 'scopes_api',
          style: {
            'text-align': 'left',
            'vertical-align': 'middle'
          }
        },
        {
          title: '申请理由',
          key: 'reason',
          style: {
            width: '388px'
          }
        },
        {
          title: '操作',
          key: 'operate',
          style: {
            'vertical-align': 'middle'
          }
        }
      ],
      companyCoreScopeData: [],
      companyCoreMultipleAddData: [],
      scopes_key_options: [],
      searchScopesName: '',
      scopeDataLoading: false,
      submitMultipleScopeAddLoading: false,
      enableMutiBtn: true,
      showSingleAdd: false
    }
  },
  components: {
    scopeAdd,
    RejectDialog
  },
  created() {
    const companyInfo = this.$store.state.companyInfo
    if (companyInfo && companyInfo.state === 1) {
      this.$LogReport.sendCustomEvent('openplat_checkscope_page_load')
      this.renderScopeList()
      this.renderScopesKeyOptions()
    } else {
      this.$router.push({
        name: 'companyCore'
      })
    }
  },
  computed: {
    _companyCoreScopeData_() {
      if (this.searchScopesName) {
        return this.companyCoreScopeData.filter(i => i.scopes_name.indexOf(this.searchScopesName) !== -1)
      }
      return this.companyCoreScopeData
    },
    multipleScopeSelectCount() {
      return this.companyCoreScopeData.filter(i => i.scope_select).length
    },
    reasonNum () {
      let num = 0
      this.companyCoreMultipleAddData.forEach((item) => {
        if (item.reason) {
          num ++
        }
      })
      return num
    }
  },
  methods: {
    getPath (row) {
      switch (row.id) {
        case 'USER_INFO':
          return '/doc/4/feb66f99-7d87-c206-00e7-d84164cd701c'

        case 'USER_DATA':
          return '/doc/4/90936ab5-7c06-e24f-2ad0-0fd6e10c7386'

        case 'ARC_BASE':
          return '/doc/4/0c532c6a-e6fb-0aff-8021-905ae2409095'

        case 'ARC_DATA':
          return '/doc/4/3f46ac2e-1318-3aa0-5548-0d9fd624d520'

        case 'ATC_BASE':
          return '/doc/4/b14b77b6-8889-8c8b-2e83-17c5a4c550fb'

        case 'ATC_DATA':
          return '/doc/4/46903ddc-1264-ddac-a3c7-559d12f32118'

        case 'USER_BIND':
          return '/doc/4/8042b95d-766c-48a1-60e2-3b9f8942503d'

        default:
          break;
      }
    },
    handleShowReason (scope) {
      this.$refs.dialog.reason = scope.row.reject_reason
      this.$refs.dialog.show = true
    },
    async submitMultipleScopeAdd() {
      this.$LogReport.sendCustomEvent('openplat_scopeapply_submit_click')
      const notPass = this.companyCoreMultipleAddData.find(i => {
        if (!i.reason) {
          this.$message({
            content: `${i.scopes_name} 申请理由未填写`,
            type: 'exception',
            offset: 60,
            duration: 1500
          })
        }
        return !i.reason
      })
      if (notPass) return
      this.submitMultipleScopeAddLoading = true

      for (let i of this.companyCoreMultipleAddData) {
        await this.$api.companyScope.submit({
          client_id: this.$route.params.client_id,
          scopes: i.id + '',
          apply_reason: i.reason
        }).then(() => {
        }).catch((e) => {
          this.$message({
            content: e.message || `${i.scopes_name}申请失败`,
            type: 'exception',
            offset: 60,
            duration: 1500
          })
          if (e.message === '应用认证未通过') {
            this.$router.push({path: '/company-core'})
          }
        })
      }
      this.submitMultipleScopeAddLoading = false
      this.confirmScopeAdd()
      this.showMultipleScopeAdd = false
      this.multiStep = 1
    },
    async openSpecificScopeAdd(row) {
      this.$LogReport.sendCustomEvent('openplat_onescope_apply_click')
      if (!this.scopes_key_options.length) return
      await this.$api.companyCore.view(this.$route.params.client_id).then((res) => {
        if (res.state !== 1) {
          this.$message({
            content: '应用认证未通过',
            type: 'exception',
            offset: 60,
            duration: 1500
          })
          this.$router.push({path: '/company-core'})
          return
        }
        this.multiStep = 2
        this.showSingleAdd = true
        this.companyCoreMultipleAddData = [{
          id: row.id + '',
          scopes_name: row.scopes_name,
          scopes_api: row.scopes_api.slice(0),
          api_expand: false,
          show_api_expand: true,
          reason: ''
        }]
      })
    },
    nextMultipleSelect() {
      this.$LogReport.sendCustomEvent('openplat_batchapply_next_click')
      this.multiStep = 2
      this.companyCoreMultipleAddData = this.companyCoreScopeData.filter(i => i.scope_select).map(i => {
        return {
          id: i.id + '',
          scopes_name: i.scopes_name,
          scopes_api: i.scopes_api.slice(0),
          api_expand: false,
          show_api_expand: true,
          reason: ''
        }
      })
    },
    multipleRowSelected(row) {
      // 0 - 未获取 3 - 申请驳回
      return this.showMultipleScopeAdd && row.scope_select && (row.state === 0 || row.state === 3)
    },
    multipleRowNotSelected(row) {
      // 0 - 未获取 3 - 申请驳回
      return this.showMultipleScopeAdd && !row.scope_select && (row.state === 0 || row.state === 3)
    },
    async setMultipleScopeAdd() {
      this.$LogReport.sendCustomEvent('openplat_appmanage_batchapply_click')
      await this.$api.companyCore.view(this.$route.params.client_id).then((res) => {
        if (res.state !== 1) {
          this.$message({
            content: '应用认证未通过',
            type: 'exception',
            offset: 60,
            duration: 1500
          })
          this.$router.push({path: '/company-core'})
          return
        }
        this.showMultipleScopeAdd = !this.showMultipleScopeAdd
      })
    },
    selectScope(row, boolean) {
      const idx = this.companyCoreScopeData.findIndex(i => i === row)
      this.companyCoreScopeData[idx].scope_select = boolean
    },
    removeMultiAdd(row) {
      this.$confirm({
        mainText: '你确定要移除该权限吗？',
        subText: '移除之后在当前页面无法重新添加，重新添加该权限需要返回上一步进行。',
        showCancel: true,
        onOk: () => {
          const idx = this.companyCoreMultipleAddData.findIndex(i => i === row)
          this.companyCoreMultipleAddData.splice(idx, 1)
          const idx2 = this.companyCoreScopeData.findIndex(i => i.id === row.id)
          this.companyCoreScopeData[idx2].scope_select = false
          if (!this.companyCoreMultipleAddData.length) {
            this.multiStep = 1
          }
        },
        onCancel: () => {
          console.log('cancel')
        }
      })
    },
    renderScopeList() {
      const client_id = this.$route.params.client_id
      this.scopeDataLoading = true
      let stateArr = []
      this.$api.companyCore.view(client_id).then(data => {
        this.app_name = data.app_name
        // if (data.state !== 1) {
          // this.$message({
          //   content: '应用认证未通过',
          //   type: 'exception',
          //   offset: 60,
          //   duration: 1500
          // })
          // this.$router.push({path: '/company-core'})
        //   return
        // }
        if (!data.existOnline) {
          this.$message({
            content: '该应用线上不存在',
            type: 'exception',
            offset: 60,
            duration: 1500
          })
          this.$router.push({path: '/company-core'})
          return
        }
        if (data.privilege) {
          this.companyCoreScopeData = Object.keys(data.privilege).map(i => {
            stateArr.push(data.privilege[i].state)
            return {
              id: i + '',
              ...data.privilege[i],
              scope_select: false,
              api_expand: false,
              show_api_expand: false,
              desc_expand: false,
              show_desc_expand: false
            }
          }).sort((a, b) => a.order - b.order)
        }
        this.showExpand()
        this.scopeDataLoading = false
        this.enableMutiBtn = stateArr.findIndex((item) =>  (item !== 100 && item !== 1 && item !== 2 )) > -1
      }).catch(e => {
        this.scopeDataLoading = false
        this.$message({
          content: e.message,
          type: 'exception',
          offset: 60,
          duration: 1500
        })
      })
    },
    confirmScopeAdd() {
      this.$LogReport.sendCustomEvent('openplat_scopeapply_submit_success')
      this.showScopeAdd = false
      this.searchScopesName = ''
      this.$message({
        content: '您已提交权限申请',
        type: 'success',
        offset: 60,
        duration: 1500
      })
      this.renderScopeList()
    },
    showExpand() {
      this.companyCoreScopeData.forEach(data => {
        if (data.scopes_api.length > 1) {
          data.show_api_expand = true
        }
      })
      this.$nextTick(() => {
        const doms = document.getElementsByClassName('desc-row-expand')
        for (let i = 0; i < doms.length; i++) {
          const dom = doms[i]
          const child = dom.querySelector('.row-expand-name')
          if (child) {
            const {width} = child.getBoundingClientRect()
            if (width > dom.clientWidth) {
              this.companyCoreScopeData[i].show_desc_expand = true
            }
          }
        }
      })
    },
    renderScopeState(state) {
      switch (state) {
        case 0:
          return '<span style="color: #FA5A57;">未获取</span>'
        case 1:
          return '<span style="color: #FAAB4B;">申请中</span>'
        case 2:
          return '<span>已获取</span>'
        case 3:
          return '<span style="color: #FA5A57;">已拒绝</span>'
        case 100:
          return '<span>默认开启</span>'
        default:
          return `<span style="color: #FA5A57;">未知状态(${state})</span>`
      }
    },
    renderScopesKeyOptions() {
      this.$api.companyScope.configScopeType().then(data => {
        this.scopes_key_options = Object.keys(data).map(i => {
          return {
            label: data[i].scopes_name,
            value: i
          }
        })
      }).catch(e => {
        this.$message({
          content: e.message || '获取API组异常',
          type: 'exception',
          offset: 60,
          duration: 1500
        })
        console.error(e)
      })
    },
    onSearchScopesName(value) {
      this.searchScopesName = value
    },
    renderSearchScopeName(name) {
      if (!name) return
      if (!this.searchScopesName) return
      const idx = name.indexOf(this.searchScopesName)
      if (idx === -1) return
      const _arr_ = name.split(this.searchScopesName)
      return _arr_.join(`<span style="color: #1389BF;">${this.searchScopesName}</span>`)
    },
    tabsChange(id) {
      console.log(id)
    },
    cancelBatch() {
      this.$LogReport.sendCustomEvent('openplat_appmanage_undobatch_click')
      this.showMultipleScopeAdd = false
    }
  }
}
</script>

<style scoped lang="scss">
.company-core-scope {
  max-width: 1168px;
  min-width: 960px;
  margin: auto;
}

.company-core-scope-head {
  padding: 32px 0 34px 26px;
}

.company-core-scope-body {
  border: 1px solid #E7E7E7;
  min-height: 100px;

  .company-core-scope-body-h {
    padding: 0 26px;
    border-bottom: 1px solid #E7E7E7;

    h3 {
      padding: 25px 0;
      font-size: 24px;
      color: #212121;
      line-height: 24px;
      font-weight: 600;
    }
  }

  .company-core-scope-body-b {
    padding: 24px;

    .search-add {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;

      .search-api {
        width: 230px;
      }
    }
  }

  .company-core-scope-body-b-multiple-add {
    padding: 24px;

    .top-text {
      font-size: 14px;
      color: #505050;
      line-height: 18px;
      font-weight: 400;
    }
  }

  .company-core-scope-body-b, .company-core-scope-body-b-multiple-add {
    ::v-deep table {
      td {
        vertical-align: top;
        padding: 0;
        font-size: 0;

        .bcc-table__cell {
          box-sizing: border-box;
          padding: 16px;
          font-size: 14px;
          line-height: 20px;
          position: relative;
          overflow-y: auto;
          .bcc-iconfont {
            position: absolute;
            top: 16px;
            right: 0;
            font-size: 12px;
            color: #999999;

            &:hover {
              opacity: .8;
            }
          }

          .not-expand {
            height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .company-core-scope-body-b-multiple-add-success {
    padding: 24px;
    text-align: center;

    p {
      font-size: 16px;
      padding: 14px 0;
    }
  }
}
.reject-help-img {
  position: absolute;
  margin-left: 5px;
  cursor: pointer;
}
.scope-operate {
  color: #1389BF;
  cursor: pointer;
  &.disabled {
    cursor: not-allowed;
    opacity: .5;
  }
  margin: 0 10px;
}

.company-core-scope-body-multi-op {
  padding: 0 24px 24px;

  .multi-step {
    display: flex;
    align-items: center;
    .info {
      font-size: 14px;
      color: #999999;
      line-height: 18px;
      font-weight: 400;
      flex: 1;
    }
  }
}
::v-deep th {
  text-align: center!important;
}
</style>
